import { CREATE_CDC_CARD_ERROR, CREATE_CDC_CARD_START, CREATE_CDC_CARD_SUCCESS } from "../../types";

export default function create_card_category(state, action) {
  switch (action.type) {
    case CREATE_CDC_CARD_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case CREATE_CDC_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
    case CREATE_CDC_CARD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.detail
      };
    default:
      return { ...state };
  }
}
